window.aracwebshopPrice = window.aracwebshopPrice || (() => {
	const PRICE_NUMBER_PATTERN = /[0-9٠-٩]+[0-9٠-٩.,٫٬]*|[.,٫٬]+[0-9٠-٩]+[0-9٠-٩.,٫٬]*/;
	const PRICE_NUMBER_PATTERN_GLOBAL = /[0-9٠-٩]+[0-9٠-٩.,٫٬]*|[.,٫٬]+[0-9٠-٩]+[0-9٠-٩.,٫٬]*/g;
	const EASTERN_ARABIC_DIGITS = {
		'٠': '0',
		'١': '1',
		'٢': '2',
		'٣': '3',
		'٤': '4',
		'٥': '5',
		'٦': '6',
		'٧': '7',
		'٨': '8',
		'٩': '9'
	};
	const ARABIC_SAR_LABEL = "ر.س";
	const SAR_TOKEN_PATTERN = /SAR|ر\.س|س\.ر|ريال|\u20C1/i;
	const SAR_TOKEN_PATTERN_GLOBAL = /SAR|ر\.س|س\.ر|ريال|\u20C1/gi;
	const NON_ENGLISH_SAR_TOKEN_PATTERN = /ر\.س|س\.ر|ريال|\u20C1/i;
	const NON_ENGLISH_SAR_TOKEN_PATTERN_GLOBAL = /ر\.س|س\.ر|ريال|\u20C1/gi;

	function westernize_price_text(value) {
		return String(value)
			.replace(/[٠-٩]/g, digit => EASTERN_ARABIC_DIGITS[digit] || digit)
			.replace(/٫/g, '.')
			.replace(/٬/g, ',');
	}

	function clean_formatted_price(formatted_price) {
		if (formatted_price === null || formatted_price === undefined) return "";
		const value = String(formatted_price).trim();
		if (!value || value === "None" || value === "null" || value === "undefined") return "";
		return westernize_price_text(value);
	}

	function to_western_number(num_str) {
		let western_num_str = "";
		for (let char of String(num_str)) {
			if (EASTERN_ARABIC_DIGITS[char] !== undefined) {
				western_num_str += EASTERN_ARABIC_DIGITS[char];
			} else if (char === '٫') {
				western_num_str += '.';
			} else if (char === '٬') {
				western_num_str += '';
			} else {
				western_num_str += char;
			}
		}

		if (western_num_str.includes('.') && western_num_str.includes(',')) {
			return western_num_str.replace(/,/g, '');
		}

		if (western_num_str.includes(',')) {
			const parts = western_num_str.split(',');
			const decimal_part = parts[parts.length - 1];
			if (parts.length === 2 && decimal_part.length === 2) {
				return `${parts[0]}.${decimal_part}`;
			}
			return parts.join('');
		}

		return western_num_str;
	}

	function parse_formatted_number(formatted_price) {
		const str_base = clean_formatted_price(formatted_price);
		const num_match = str_base.match(PRICE_NUMBER_PATTERN);
		if (!num_match) return null;

		const price = parseFloat(to_western_number(num_match[0]));
		return Number.isFinite(price) ? price : null;
	}

	function parse_all_formatted_numbers(formatted_price) {
		const str_base = clean_formatted_price(formatted_price);
		return (str_base.match(PRICE_NUMBER_PATTERN_GLOBAL) || [])
			.map(num_str => parseFloat(to_western_number(num_str)))
			.filter(price => Number.isFinite(price));
	}

	function get_single_price_template(formatted_price) {
		const str_base = clean_formatted_price(formatted_price);
		const num_match = str_base.match(PRICE_NUMBER_PATTERN);
		if (!num_match) return str_base;

		const orig_num_str = num_match[0];
		const num_idx = str_base.indexOf(orig_num_str);
		let suffix = str_base.slice(num_idx + orig_num_str.length);
		const range_match = suffix.match(/^\s*(?:~|–|—|-|to|الى|إلى)\s*/i);
		if (range_match) {
			suffix = "";
		}

		return str_base.slice(0, num_idx + orig_num_str.length) + suffix;
	}

	function format(price, formatted_base_price) {
		if (price === null || price === undefined || price === "") return "";
		const parsed_price = parseFloat(price);
		if (!Number.isFinite(parsed_price)) return "";

		const val = parsed_price.toFixed(2);
		if (!formatted_base_price) return val;

		const str_base = String(formatted_base_price);
		const num_match = str_base.match(PRICE_NUMBER_PATTERN);
		if (!num_match) return `${val} ${str_base}`.trim();

		const orig_num_str = num_match[0];
		const num_idx = str_base.indexOf(orig_num_str);

		let prefix = str_base.slice(0, num_idx);
		let suffix = str_base.slice(num_idx + orig_num_str.length);

		const is_ar = (
			document.documentElement.lang === 'ar' ||
			document.documentElement.dir === 'rtl' ||
			(document.documentElement.lang || '').startsWith('ar')
		);

		if (is_ar) {
			if (SAR_TOKEN_PATTERN.test(prefix) || SAR_TOKEN_PATTERN.test(suffix)) {
				prefix = prefix.replace(SAR_TOKEN_PATTERN_GLOBAL, '').trim();
				suffix = suffix.replace(SAR_TOKEN_PATTERN_GLOBAL, '').trim();
				suffix = suffix ? `${suffix} ${ARABIC_SAR_LABEL}` : ` ${ARABIC_SAR_LABEL}`;
			}
		} else if (NON_ENGLISH_SAR_TOKEN_PATTERN.test(prefix) || NON_ENGLISH_SAR_TOKEN_PATTERN.test(suffix)) {
			prefix = prefix.replace(NON_ENGLISH_SAR_TOKEN_PATTERN_GLOBAL, 'SAR').trim();
			suffix = suffix.replace(NON_ENGLISH_SAR_TOKEN_PATTERN_GLOBAL, '').trim();
			if (!prefix.includes('SAR')) prefix = "SAR ";
			if (prefix === 'SAR') prefix = "SAR ";
		}

		return westernize_price_text(`${prefix}${val}${suffix}`);
	}

	function normalize(formatted_price) {
		const clean_price = clean_formatted_price(formatted_price);
		const price = parse_formatted_number(clean_price);
		if (price === null) return clean_price;

		const all_prices = parse_all_formatted_numbers(clean_price);
		if (all_prices.length > 1 && all_prices.every(value => value === all_prices[0])) {
			return format(price, get_single_price_template(clean_price));
		}

		return format(price, clean_price);
	}

	function get_uom_display(price, formatted_price, formatted_base_price) {
		const formatted = clean_formatted_price(formatted_price);
		if (formatted) {
			const parsed_price = parse_formatted_number(formatted);
			return parsed_price === null ? formatted : format(parsed_price, get_single_price_template(formatted));
		}

		const parsed_price = parseFloat(price);
		if (!Number.isFinite(parsed_price) || parsed_price <= 0) return "";
		return format(parsed_price, get_single_price_template(formatted_base_price));
	}

	function get_uom_label(uom, conversion_factor) {
		const uom_label = String(uom === null || uom === undefined ? "" : uom).trim();
		const factor = parseFloat(conversion_factor || 1);
		if (!uom_label) return "";
		if (Number.isFinite(factor) && factor > 1) {
			const factor_label = String(Math.round((factor + Number.EPSILON) * 1000000) / 1000000);
			return `${factor_label} / ${uom_label}`;
		}
		return uom_label;
	}

	function get_initial_price(item) {
		let display = normalize(item && item.formatted_price);
		let base_formatted = display;

		if (item && item.uoms && item.uoms.length > 0) {
			const first_uom = item.uoms[0];
			const uom_display = get_uom_display(
				first_uom.price_list_rate,
				first_uom.formatted_price,
				item.formatted_price
			);

			if (uom_display) {
				display = uom_display;
				base_formatted = uom_display;
			}
		}

		return {
			display: display || "",
			base_formatted: base_formatted || ""
		};
	}

	function update_price_element($price_el, price, formatted_price) {
		if (!$price_el || !$price_el.length) return;

		const base_formatted = $price_el.data('base-formatted') || $price_el.text().trim();
		const display = get_uom_display(price, formatted_price, base_formatted);
		if (!display) return;

		$price_el
			.text(display)
			.attr('data-base-formatted', display)
			.data('base-formatted', display)
			.addClass('formatted-en-style');
	}

	function escape_attr(value) {
		return String(value === null || value === undefined ? "" : value)
			.replace(/&/g, '&amp;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;');
	}

	function safe_internal_url(value, fallback = "#") {
		const raw = String(value === null || value === undefined ? "" : value).trim();
		if (!raw || /[\u0000-\u001f\u007f]/.test(raw)) {
			return escape_attr(fallback);
		}

		try {
			const candidate = raw.startsWith("/") ? raw : `/${raw}`;
			const url = new URL(candidate, window.location.origin);
			if (url.origin !== window.location.origin) {
				return escape_attr(fallback);
			}
			return escape_attr(`${url.pathname}${url.search}${url.hash}`);
		} catch (error) {
			return escape_attr(fallback);
		}
	}

	function safe_image_url(value) {
		const raw = String(value === null || value === undefined ? "" : value).trim();
		if (!raw || /[\u0000-\u001f\u007f]/.test(raw)) return "";
		if (/^data:image\/(?:gif|jpe?g|png|webp);base64,[a-z0-9+/=\s]+$/i.test(raw)) {
			return escape_attr(raw);
		}
		if (/^blob:/i.test(raw)) return escape_attr(raw);

		try {
			const url = new URL(raw, window.location.origin);
			if (!['http:', 'https:'].includes(url.protocol)) return "";
			return escape_attr(url.href);
		} catch (error) {
			return "";
		}
	}

	function safe_color(value, fallback) {
		const candidate = String(value || "").trim();
		const supports_color = (
			candidate &&
			typeof window !== "undefined" &&
			window.CSS &&
			typeof window.CSS.supports === "function" &&
			window.CSS.supports("color", candidate)
		);
		return escape_attr(supports_color ? candidate : fallback);
	}

	return {
		escape_attr,
		escape_html: escape_attr,
		format,
		get_initial_price,
		get_uom_display,
		get_uom_label,
		normalize,
		parse_formatted_number,
		safe_color,
		safe_image_url,
		safe_internal_url,
		update_price_element
	};
})();
